import React from "react";

import { useApolloNetworkStatus } from "../../config/apollo";

function getInitials(name) {
  if (!name) return "U";
  return name.slice(0, 2).toUpperCase();
}

export default function AgentToolbar() {
  const apolloStatus = useApolloNetworkStatus();
  const username = localStorage.getItem("user") || "";
  const initials = getInitials(username);
  const isLoading =
    apolloStatus.numPendingQueries > 0 || apolloStatus.numPendingMutations > 0;

  return (
    <div
      style={{
        height: 56,
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 24px",
        flexShrink: 0,
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {isLoading && (
          <div
            style={{
              width: 16,
              height: 16,
              border: "2px solid #e5e7eb",
              borderTopColor: "#84cc16",
              borderRadius: "50%",
              animation: "spin 0.7s linear infinite",
            }}
          />
        )}
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            backgroundColor: "#84cc16",
            color: "#fff",
            fontSize: 13,
            fontWeight: 600,
            fontFamily: "'Inter', sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "default",
            userSelect: "none",
          }}
          title={username}
        >
          {initials}
        </div>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
